export enum ProjectOAuth2Auth0Prompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
}
